var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-12 gap-6"},[_c('UserCard',{attrs:{"user":_vm.user,"profile":_vm.profile}}),_c('div',{staticClass:"col-span-12 lg:col-span-8 xxl:col-span-9"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }